import { render, staticRenderFns } from "./BindsAppDrawer.vue?vue&type=template&id=aa710aaa&"
import script from "./BindsAppDrawer.vue?vue&type=script&lang=js&"
export * from "./BindsAppDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports